'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _timeUtil = require('../../../common/utils/timeUtil');

var _socketConstants = require('./socketConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map({
    status: _socketConstants.SOCKET_CONNECTION_STATUS.CONNECTED,
    channels: Immutable.List(),
    boardChannels: Immutable.List()
});

var updateChannels = function updateChannels(state, action) {
    return state.withMutations(function (mutableState) {
        return mutableState.update('channels', function (channels) {
            return channels.filter(function (channelId) {
                return action.left.indexOf(channelId) === -1;
            }).concat(Immutable.List(action.joined));
        }).set('boardChannels', Immutable.List(action.boardChannels));
    });
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _socketConstants.SOCKET_CONNECT:
            return state.set('status', _socketConstants.SOCKET_CONNECTION_STATUS.CONNECTED).set('disconnectedTime', null);
        case _socketConstants.SOCKET_DISCONNECT:
            return state.set('status', _socketConstants.SOCKET_CONNECTION_STATUS.DISCONNECTED).set('disconnectTime', (0, _timeUtil.getTimestamp)());
        case _socketConstants.CHANNELS_UPDATED:
            return updateChannels(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/socket/socketReducer.js
// module id = 2143
// module chunks = 0